module.exports = __webpack_public_path__ + "static/media/maps-cover-image.a2a1922b.jpg";